<template>
  <div>
    <section ref="raizNinos" class="lluvia-sobres">
      <!-- Elementos decorativos laterales (Flores y Ramas) -->
      <div class="decoracion-lateral decoracion-izq">
        <img :src="floresPng" alt="Flores Izquierda" class="flor-decorativa a-animar-flor-ninos-izq" />
        <img :src="ramasPng" alt="Ramas Izquierda" class="rama-decorativa a-animar-rama-ninos-izq" />
      </div>
      <div class="decoracion-lateral decoracion-der">
        <img :src="floresPng" alt="Flores Derecha" class="flor-decorativa a-animar-flor-ninos-der" />
        <img :src="ramasPng" alt="Ramas Derecha" class="rama-decorativa a-animar-rama-ninos-der" />
      </div>

      <!-- CORONA DECORATIVA CENTRAL -->
      <div class="contenedor-corona a-animar-corona">
        <img :src="coronaPng" alt="Corona" class="corona-central" />
      </div>

      <div class="contenido">
        <!-- 1. SECCIÓN: COURT OF HONOR -->
        <div class="bloque-honor">
          <h2 class="titulo-corte a-animar-ninos">Court Of Honor</h2>
          
          <div class="chambelan-contenedor a-animar-ninos">
            <p class="rol">Chambelán de Honor</p>
            <p class="nombre-destacado">Emiliano Pérez</p>
          </div>

          <div class="damas-contenedor a-animar-ninos">
            <p class="rol">Damas</p>
            <ul class="lista-damas">
              <li>Jocelyn Rojas</li>
              <li>Elisly Domínguez</li>
              <li>Jazzlene Meza</li>
              <li>Aurora Arreola</li>
            </ul>
          </div>
        </div>

        <!-- SEPARADOR ELEGANTE 1 -->
        <div class="separador a-animar-ninos">
          <span class="linea"></span>
          <span class="rombo">♦</span>
          <span class="linea"></span>
        </div>

        <!-- 2. SECCIÓN: SPECIAL THANKS! -->
        <div class="bloque-padres">
          <h2 class="titulo a-animar-ninos">
            <span class="serif">Special Thanks!</span>
          </h2>

          <p class="texto a-animar-ninos">
            A big thank you to all my padrinos/madrinas for your love, guidance, and generous support in making this day possible!
          </p>

          <!-- SEPARADOR ELEGANTE 2 -->
          <div class="separador separador-chico a-animar-ninos">
            <span class="linea"></span>
            <span class="rombo">♦</span>
            <span class="linea"></span>
          </div>

          <!-- BLOQUE PADRINOS DE HONOR REESTRUCTURADO Y BONITO -->
          <div class="bloque-padrinos a-animar-ninos">
            <p class="subtitulo-padrinos">Padrinos de Honor</p>
            <div class="contenedor-padres">
              <h3 class="nombre-protagonista">
                <span class="inicial-titulo">A</span>lonso Soria
              </h3>
              <span class="ampersand">&</span>
              <h3 class="nombre-protagonista">
                Delia Gaz
              </h3>
            </div>
          </div>
        </div>
      </div>

      <!-- LLUVIA MÁGICA SIMULTÁNEA -->
      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>

      <div class="rasgado rasgado-inferior"></div>
    </section>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import sobrePng from '@/assets/ss.png'
import floresPng from '@/assets/f.png'
import ramasPng from '@/assets/ramas.png'
import coronaPng from '@/assets/cc.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'SeccionPadres',
  setup() {
    const raizNinos = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    let stInstanceNinos = null

    const crearLluvia = (contenedorEl, lado, cantidad) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedorEl.appendChild(el)

        gsap.fromTo(
          el,
          { xPercent: lado === 'der' ? 110 : -10, yPercent: -10, opacity: 0 },
          {
            xPercent: lado === 'der' ? -20 : 120,
            yPercent: 140,
            opacity: 0.9,
            duration: 2.2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      const elementosAAnimar = raizNinos.value.querySelectorAll('.a-animar-ninos')
      const florNinosIzq = raizNinos.value.querySelector('.a-animar-flor-ninos-izq')
      const florNinosDer = raizNinos.value.querySelector('.a-animar-flor-ninos-der')
      const ramaNinosIzq = raizNinos.value.querySelector('.a-animar-rama-ninos-izq')
      const ramaNinosDer = raizNinos.value.querySelector('.a-animar-rama-ninos-der')
      const coronaCentro = raizNinos.value.querySelector('.a-animar-corona')

      // Set inicial invisible para evitar parpadeos (FOUC)
      gsap.set(elementosAAnimar, { opacity: 0, y: 30 })
      gsap.set([florNinosIzq, florNinosDer], { opacity: 0, scale: 0.6, rotation: (i) => i === 0 ? -20 : 20 })
      gsap.set([ramaNinosIzq, ramaNinosDer], { opacity: 0, y: -35, scaleY: 0.8 })
      gsap.set(coronaCentro, { opacity: 0, scale: 0.4, y: -25 })

      stInstanceNinos = ScrollTrigger.create({
        trigger: raizNinos.value,
        start: 'top 80%',
        once: true,
        onEnter: () => {
          // Lluvia fluida
          crearLluvia(lluviaNinosDer.value, 'der', 9)
          crearLluvia(lluviaNinosIzq.value, 'izq', 9)

          // Timeline fluida y consecutiva
          const tlUnica = gsap.timeline()
          
          tlUnica
            // 1. Flores
            .to([florNinosIzq, florNinosDer], {
              opacity: 1,
              scale: 1,
              rotation: 0,
              duration: 0.55,
              ease: 'back.out(1.4)'
            })
            // 2. Ramas
            .to([ramaNinosIzq, ramaNinosDer], {
              opacity: 1,
              y: 0,
              scaleY: 1,
              duration: 0.5,
              ease: 'power3.out'
            }, '-=0.35')
            // 3. Corona central
            .to(coronaCentro, {
              opacity: 1,
              scale: 1,
              y: 0,
              duration: 0.65,
              ease: 'back.out(1.7)'
            }, '-=0.4')
            // 4. Cascada del contenido en orden descendente
            .to(elementosAAnimar, { 
              opacity: 1, 
              y: 0, 
              duration: 0.55, 
              stagger: 0.08, 
              ease: 'power2.out' 
            }, '-=0.4')
        }
      })
    })

    onUnmounted(() => {
      stInstanceNinos?.kill()
    })

    return {
      raizNinos,
    
      sobrePng,
      floresPng,
      ramasPng,
      coronaPng
    }
  }
}
</script>

<style scoped>
/* CONTENEDOR PRINCIPAL */
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  background: #e793b6;
  overflow: hidden;
}

/* DECORACIÓN LATERAL */
.decoracion-lateral {
  position: absolute;
  top: 10px;
  width: 90px;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}

.decoracion-izq {
  left: -15px;
}

.decoracion-der {
  right: -15px;
  transform: scaleX(-1);
}

.flor-decorativa {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 4;
  margin-top: -45px;
}

.rama-decorativa {
  width: 75%;
  height: auto;
  margin-top: -42px;
  transform-origin: top center;
  z-index: 2;
}

/* CORONA CENTRAL */
.contenedor-corona {
  margin: 0 auto 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 3;
  position: relative;
}

.corona-central {
  width: 166px;
  height: auto;
  filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.15));
}

/* CONTENIDO */
.contenido {
  position: relative;
  z-index: 2;
}

/* SEPARADORES ELEGANTES */
.separador {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 28px auto;
  max-width: 250px;
  width: 100%;
}

.separador-chico {
  max-width: 180px;
  margin: 22px auto 26px;
}

.separador .linea {
  flex: 1;
  display: inline-block;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.65);
}

.separador .rombo {
  color: #fff;
  font-size: 11px;
  opacity: 0.85;
  line-height: 1;
}

/* BLOQUE DE COURT OF HONOR */
.bloque-honor {
  margin: 10px auto 20px;
  color: #fff;
}

.titulo-corte {
  font-family: 'Great Vibes', cursive;
  font-size: 48px;
  margin-bottom: 24px;
  color: #fff;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.08);
}

.chambelan-contenedor {
  margin-bottom: 26px;
}

.damas-contenedor {
  margin-bottom: 10px;
}

.rol {
  font-family: 'quote', serif;
  font-size: 20px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  opacity: 0.95;
  margin-bottom: 6px;
}

.nombre-destacado {
  font-family: 'Great Vibes', cursive;
  font-size: 34px;
  margin: 0;
  font-weight: normal;
}

.lista-damas {
  list-style: none;
  padding: 0;
  margin: 8px 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.lista-damas li {
  font-family: 'Great Vibes', cursive;
  font-size: 34px;
  line-height: 1.2;
}

/* BLOQUE DE PADRES (SPECIAL THANKS!) */
.bloque-padres {
  margin: 20px auto 10px;
}

.titulo {
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}

.titulo .serif {
  font-family: 'britishgruesa', serif;
  font-size: 52px;
  display: inline-block;
}

.texto {
  font-family: 'quote', serif;
  font-size: 16px;
  line-height: 1.55;
  color: #fff;
  max-width: 420px;
  margin: 12px auto 18px;
  padding: 0 10px;
}

/* ESTILOS REFINADOS PARA PADRINOS DE HONOR */
.bloque-padrinos {
  margin-top: 15px;
}

.subtitulo-padrinos {
  font-family: 'quote', serif;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #ffffff;
  opacity: 0.95;
  margin-bottom: 12px;
}

.contenedor-padres {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.nombre-protagonista {
  font-family: 'Great Vibes', cursive;
  font-size: 40px;
  color: #fff;
  margin: 0;
  font-weight: normal;
  letter-spacing: 0.02em;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.06);
}

.ampersand {
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px;
  color: #fff;
  line-height: 1;
  margin: 2px 0;
  opacity: 0.9;
}

.inicial-titulo {
  font-family: 'titulos', serif;
}

/* ELEMENTOS DE LLUVIA */
.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia {
  position: absolute;
  width: 28px;
  top: -10%;
  opacity: .9;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,.1));
}
</style>